import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation GenerateVideoServiceAPIKey($serviceUid: String!){
        video_service_generate_api_key (uid: $serviceUid) {
            success
        }
    }
`;

export async function videoServiceApiKeyCreate(serviceUid: string):
    Promise<{ success: boolean }>
{
    const result: FetchResult<{ video_service_generate_api_key: { success: boolean } }> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { serviceUid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.video_service_generate_api_key;
}
